export enum PoolerJobsTabIdEnum {
  NEW = 'OPEN',
  ANSWERED = 'ANSWERED',
  CLOSED = 'CLOSED',
  ARCHIVED = 'ARCHIVED',
}
